export default "__VITE_ASSET__DEHf6yYw__"